import { RaRecord } from 'react-admin';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { formatCurrency } from 'utils';

export type SimpleCurrencyFieldProps<T extends RaRecord = RaRecord> = {
  onClick?: (record?: T) => void;
  source: keyof T;
  currency?: string;
} & Omit<FunctionFieldProps, 'render'>;

export const SimpleCurrencyField = <T extends RaRecord = RaRecord>({
  source,
  ...rest
}: SimpleCurrencyFieldProps<T>) => (
  <FunctionField
    render={(record: T) => {
      if (!record?.[source]) {
        return rest?.emptyText;
      }

      return formatCurrency(record?.[source] ? Number(record?.[source]) : 0);
    }}
    {...rest}
  />
);
